/**
 * v4 Button components require a Next.js app consumer.
 * Button uses `next/link` as MUI `LinkComponent` for in-app navigation.
 * Make sure `next` is installed in the host app.
 */
export { default, default as Button } from './Button';
export * from './types';
export { getOverrides, isIconOnly } from './utils';
